import { Component, OnInit, EventEmitter, ViewChild, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { CommonService } from 'src/app/services/common.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HeadService } from 'src/app/services/common/headservice';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Router } from '@angular/router';
import { DateObject, Document_Upload_File, SCREEN_CONTROL, SCREEN_RESPONSE, ScreenResponseModel } from 'src/app/models/common';
import { DatePipe } from '@angular/common';
import { UserService } from 'src/app/services/user.service';
import { serviceConstants } from 'src/app/constants/service.constants';
import { FileService } from 'src/app/services/file.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-grants-authorized-signer-char-view-modal',
  templateUrl: './grants-authorized-signer-char-view-modal.component.html',
  styleUrl: './grants-authorized-signer-char-view-modal.component.scss'
})
export class GrantsAuthorizedSignerCharViewModalComponent {
  staticformFields: any;
  prefixList : any[];
  @Input() public Content: any;
  formFields;
  appid: string = "";
  authorizedSigneePayeeForm: UntypedFormGroup;
  content: any;
  action: Subject<any> = new Subject();
  permission: string;
  formData: FormData;
  humanizeBytes: Function;
  dragOver: boolean;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;

    Application_Type_ID: string = '';
    Grantsapp: any;
    userType: string = "";
    user: any;
    SCREEN_MODEL: any = null;
    ScreenName: string;
    submittedresponse: SCREEN_RESPONSE[] = [];
  //datepipe: any;
  //userService: any;
  IsFormToched:any;
  GeneralInformationFields: any;
  isDateModified: boolean = false;
  Full_Date: DateObject;
  tooltipValue: string;

  constructor(
    private summaryService: GrantsSummaryService,
    public modalRef: NgbActiveModal,
    private grantsDatashare:GrantsDatashareService,
    private header:HeadService,
    private modalService:NgbModal,
    private router: Router,
    public datepipe: DatePipe,
    private readonly userService: UserService,
    private commonService: CommonService,
  private fileService :FileService)  { }

  ngOnInit() {
    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.grantsDatashare.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
    this.GetParentScreenFieldsConfigControls('GCH01');
    this.Grantsapp = this.commonService.getGrantsApp();
    this.user = this.userService.getUserDetais();

    this.appid = this.commonService.appId;
    this.grantsDatashare.GrantApplicationID.subscribe(x => {
      this.appid = x;
    });
    this.GetScreenConfigControls('SCR-037');
    this.userType = this.userService.getUserType();
    this.getOnIntMethods();
  }
 changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl = question.ControlValue;
      if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControl.indexOf(item.value) > -1;
        })
        let labellist = [];
        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }

    }, 200);

  }

getOnIntMethods()
{
  this.GetMasterData();

  // this.authorizedSigneePayeeForm = new UntypedFormGroup({
  //   ID: new UntypedFormControl(null),
  //   APPLICATION_ID: new UntypedFormControl(null),
  //   PREFIX: new UntypedFormControl("", [Validators.required]),
  //   FIRST_NAME: new UntypedFormControl("", [Validators.required]),
  //   MIDDLE_NAME: new UntypedFormControl(""),
  //   LAST_NAME: new UntypedFormControl("", [Validators.required]),
  //   EMAIL: new UntypedFormControl("", [Validators.required]),
  //   ADDRESS: new UntypedFormControl("", [Validators.required]),
  //   IS_DEFAULT_CONTACT: new UntypedFormControl(false),
  //   REGISTRATION_ID: new UntypedFormControl(null)
  // });
  if (this.Content.heading == "View") {
    this.GetEditData();
   // this.authorizedSigneePayeeForm.disable();
  }
  if (this.Content.heading == "Edit") {
    this.GetEditData();
  }
  this.permission = this.commonService.getPagePermission("SCR037").toLowerCase();
  if (this.permission === 'view') {
    setTimeout(() => {
      this.authorizedSigneePayeeForm.disable({ emitEvent: false });
    }, 100);
  }
}

  GetEditData(): void {
    this.summaryService.getCharSignee(this.Content.content.id).subscribe(summary => {
      // this.authorizedSigneePayeeForm.patchValue({
      //   ID: summary["ID"],
      //   APPLICATION_ID: summary["APPLICATION_ID"],
      //   PREFIX: summary["PREFIX"],
      //   FIRST_NAME: summary["FIRST_NAME"],
      //   MIDDLE_NAME: summary["MIDDLE_NAME"],
      //   LAST_NAME: summary["LAST_NAME"],
      //   EMAIL: summary["EMAIL"],
      //   ADDRESS: summary["ADDRESS"],
      //   IS_DEFAULT_CONTACT: summary["IS_DEFAULT_CONTACT"],
      //   REGISTRATION_ID: summary["REGISTRATION_ID"]
      // });
      // this.extendedForm.rowid=summary.ID;
      // this.extendedForm.getResponse();
      if(summary!=null && summary!=""){
        this.BindDataToDynamicControls();
        this.BindDataToStaticControls(summary);
      }
    });
   
  }
  // getStaticFiledsData(screenCode:string) {
  //   this.commonService.getScreenStaticFields(screenCode,this.appid)
  //     .subscribe(summary => {
  //       this.staticformFields = summary["Data"];
  //     });
  // }
  ClosePopup() {
    this.modalRef.close();
  }

  GetMasterData() {
    this.prefixList = [];
     var signeeId="-1";
      if (this.Content.content !== null && this.Content.content !== undefined && this.Content.content.id !== undefined && this.Content.content.id !== null)
      {
        signeeId=this.Content.content.id;
      }
     this.summaryService.GetMasterScreenData("api/gmchar/getmasterdata?ApplicationID="+this.appid+"&signeeId="+signeeId).subscribe(summary => {
      this.prefixList = summary["MasterData3"];
      this.prefixList = [{ label: "Select", value: null, checked: true }].concat(this.prefixList);
    });
  }

  
    validateControls(): boolean {
      let isValid = true;
      let message = "";
      this.staticformFields.forEach((item) => {
        if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
          switch (item.CONTROL) {
            case 1:
            case 2:
            case 3:
            case 5:
            case 4:
            case 11:
              if (!item.ControlValue) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 10:
              if (!(item.ControlValue) || (item.ControlValue != null && item.ControlValue.length == 0)) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 6:
              let seletedItem = "";
  
              for (let c = 0; c < item.SourceItems.length; c++) {
                if (item.SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = item.SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + item.SourceItems[c].value;
                }
              }
              item.ControlValue = seletedItem;
              if (!item.ControlValue) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
  
            case 7:
              if (!item.ControlValue) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 8:
              if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 9:
              break;
          }
        }
      });
  
      if (isValid) {
        let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);
        if (!inactiveValueControls || inactiveValueControls.length == 0) {
        }
        else {
          isValid = false;
          let dataMsg = inactiveValueControls.join("</br>");
          this.commonService.ValidationBanner(dataMsg);
        }
      }
      if (!isValid)
        this.commonService.ValidationBanner(message);
      return isValid;
    }

  SaveSignee() {
    if (this.validateControls()) {
      for (let i = 0; i < this.staticformFields.length; i++) {
          switch (this.staticformFields[i].CONTROL) {
            case 6:
              let seletedItem = "";
              for (let c = 0; c < this.staticformFields[i] .SourceItems.length; c++) {
                if (this.staticformFields[i].SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = this.staticformFields[i].SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
                }
              }
              this.staticformFields[i].ANSWER = seletedItem;
              break;
            case 8:
              this.staticformFields[i].UploadedDocuments = [];
              if (this.staticformFields[i].UploadFiles) {
                for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                  if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                    this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                  }
                }
                this.staticformFields[i].ANSWER = null;
                this.staticformFields[i].ControlValue = null;
              }
              break;
            case 10:
              let SelectedValues = this.staticformFields[i].ControlValue;
              if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
                this.staticformFields[i].ANSWER = SelectedValues.join(",");
              }
              else {
                this.staticformFields[i].ANSWER = "";
              }
              this.staticformFields[i].SUBFIELDNAME = "";
              //this.staticformFields[i].ControlValue = null;
              break;
            case 5:
              let controlanswer = this.staticformFields[i].ControlValue;
              if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                this.staticformFields[i].ANSWER = formd;
              }
              else {
                this.staticformFields[i].ANSWER = controlanswer;
              }
              break;
            default:
              this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
              break;
          }
        }
        
        let uploadData = new FormData();
        //uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
      let FinalControls = _.cloneDeep(this.staticformFields);
      FinalControls.forEach((item) => {
        switch (item.CONTROL) {
          case 10:
            item.ControlValue = null;
            break;
        }
      });
      uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
        uploadData.append("ModuleID", "4");
        uploadData.append("APPLICATION_TYPE_ID",this.Application_Type_ID);
        uploadData.append("ID",this.Content.content.id);

      if (this.Content.heading == "Add") {
        if (!this.appid) {
          this.SaveCharitable_GM_APP().subscribe((res) => {
            if (res.Status === 0) {
              this.appid = res.Data;
              this.grantsDatashare.setGrantApplicationID(this.appid);
              this.commonService.appId = this.appid;
              uploadData.append("Appid", this.appid);
              this.summaryService.Insert("api/gmchar/insert", uploadData).subscribe(result => {
                if (result.Status == 0) {
                  this.IsFormToched = false;
                  if (result.Status === 0) {
                    this.commonService.SuccessBanner(this.ScreenName + " added successfully.");
                    this.modalRef.close('yes');
                    
                    this.commonService.refreshApplicationPage(this.appid,'grants');
                  }
                  else {
                    this.commonService.ValidationBanner(result.Message);
                  }

                } else {
                  this.commonService.ValidationBanner(result.Message);
                }
              });
            }
            else {
              this.commonService.ValidationBanner(res.Message);
            }
          })
        }
        else {
          uploadData.append("Appid", this.appid);
          this.summaryService.Insert("api/gmchar/insert", uploadData).subscribe(result => {
            if (result.Status == 0) {
              this.IsFormToched = false;
              if (result.Status === 0) {
                this.commonService.SuccessBanner(this.ScreenName + " added successfully.");
                this.modalRef.close('yes');
               
              }
              else {
                this.commonService.ValidationBanner(result.Message);
              }

            } else {
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }
      }
      else {
        let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);
        if (!inactiveValueControls || inactiveValueControls.length == 0) {
          uploadData.append("Appid", this.appid);
          this.summaryService.FilesInsert("api/gmchar/update", uploadData).subscribe(result => {
            this.IsFormToched = false;
            if (result.Status === 0) {
              if (result.ErrorCode === "NOCHANGES") {
                this.GetEditData();
                this.commonService.ValidationBanner(result.Message);
              }
              else {
                this.commonService.SuccessBanner(this.ScreenName + " updated successfully.");
                this.modalRef.close('yes');
              }
            }
            else {
              this.GetEditData();
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }
        else {
          let dataMsg = inactiveValueControls.join("</br>");
          this.commonService.ValidationBanner(dataMsg);
        }
      }

    }
  }

  // copyFromReg() {
  //   this.GetCopyData();
  // }

  // GetCopyData(): void {
  //   this.summaryService.getSigneeCopyData(this.appid).subscribe(summary => {
  //     this.authorizedSigneePayeeForm.patchValue({
  //      // ID: summary["ID"],
  //       APPLICATION_ID: summary["APPLICATION_ID"],
  //       PREFIX: summary["PREFIX"],
  //       FIRST_NAME: summary["FIRST_NAME"],
  //       MIDDLE_NAME: summary["MIDDLE_NAME"],
  //       LAST_NAME: summary["LAST_NAME"],
  //       EMAIL: summary["EMAIL"],
  //       ADDRESS: summary["ADDRESS"],
  //       IS_DEFAULT_CONTACT: summary["IS_DEFAULT_CONTACT"],
  //      // REGISTRATION_ID: summary["REGISTRATION_ID"]
  //     });
  //   });
  // }
   GetScreenConfigControls(screenCode: string) {
      this.commonService.GetScreenConfigControls(screenCode, this.appid, this.appid, (ScreenData) => {
        this.SCREEN_MODEL = ScreenData;
        this.ScreenName = this.SCREEN_MODEL?.NAME;
        this.staticformFields = ScreenData["SCREEN_CONTROL"];
        //this.GetMasterData();
        this.getOnIntMethods();
      });
    }
    BindDataToDynamicControls() {
      if (this.appid != null && this.appid != undefined && this.appid != "") {
        let sr = new ScreenResponseModel();
        sr.Id = "SCR-037";
        sr.RowId = this.Content.content.id;
        sr.AppId = this.appid;
        this.summaryService.getScreenResponse(sr).subscribe(summary => {
          this.submittedresponse = summary;
          if (this.submittedresponse != null && this.submittedresponse.length > 0) {
            for (let i = 0; i < this.staticformFields.length; i++) {
              var response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);
  
              if (response != null && response.length > 0) {
                if (this.staticformFields[i].CONTROL == '6') {
                  if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                    this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                    var options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                    if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                      for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                        if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                          this.staticformFields[i].SourceItems[c].Checked = true;
                        }
                        else {
                          this.staticformFields[i].SourceItems[c].Checked = false;
                        }
                      }
                    }
  
                  }
                }
                else if (this.staticformFields[i].CONTROL == '10') {
                  this.staticformFields[i].NotimesChanged = 0;
                  if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                    this.staticformFields[i].ControlValue = [];
  
                    var options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                    options1.forEach((item) => {
                      this.staticformFields[i].ControlValue.push(item);
                    });
                    this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  }
                  else {
                    this.staticformFields[i].ControlValue = [];
                  }
                }
                else if (this.staticformFields[i].CONTROL == '5') {
                  if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                    let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.staticformFields[i].ControlValue = formd;
  
                    if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                      let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                      this.staticformFields[i].ControlValue = formd;
                    }
  
                  }
  
                }
                else {
                  this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                this.staticformFields[i].UploadFiles = response[0].UploadFiles;
                if (this.staticformFields[i].CONTROL == '4') {
                  this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
                }
              }
  
            }
          }
  
        });
      }
    }
    BindDataToStaticControls(MainObjData: any): any {
      for (var i = 0; i < this.staticformFields.length; i++) {
        switch (this.staticformFields[i].FIELD_CODE) {
          case "CHAR_PREFIX":
            this.staticformFields[i].ControlValue = MainObjData.PREFIX;
            break;
          case "CHAR_FIRST_NAME":
            this.staticformFields[i].ControlValue = MainObjData.FIRST_NAME;
            break;
          case "CHAR_MIDDLE_NAME":
            this.staticformFields[i].ControlValue = MainObjData.MIDDLE_NAME;
            break;
          case "CHAR_LAST_NAME":
            this.staticformFields[i].ControlValue = MainObjData.LAST_NAME;
            break;
          case "CHAR_EMAIL":
            this.staticformFields[i].ControlValue = MainObjData.EMAIL;
            break;
          case "CHAR_ADDRESS":
            this.staticformFields[i].ControlValue = MainObjData.ADDRESS;
            break;
          case "CHAR_IS_DEFAULT_CONTACT":
            this.staticformFields[i].ControlValue = MainObjData.IS_DEFAULT_CONTACT;
            break;
  
        }
  
        if (this.staticformFields[i].CONTROL == '4') {
          this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
        }
      }
  
    }
    ApplyConditions($event, question, makeNull) {
      let value = $event.value;
      if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
        question.Control_Condtions = [];
      }
      let displayControlIDS = [];
      let hideControlIDS = [];
      let enableControlIDS = [];
      let disbledControlIDS = [];
  
      question.Control_Condtions.forEach((item) => {
        if (item.Mapped_Control_Value == value) {
          item.ConditionsList.forEach((otemCon) => {
            switch (otemCon.Mapped_Condtion) {
              case "1": //display
                if (displayControlIDS.length == 0) {
                  displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                }
                else {
                  let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                  if (disCntrIds && disCntrIds.length > 0) {
                    disCntrIds.forEach((id) => {
                      if (!displayControlIDS.includes(id)) {
                        displayControlIDS.push(id);
                      }
                    })
                  }
                }
  
                break;
              case "2": //enabled
                if (enableControlIDS.length == 0) {
                  enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                }
                else {
                  let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                  if (enableCntrIds && enableCntrIds.length > 0) {
                    enableCntrIds.forEach((id) => {
                      if (!enableControlIDS.includes(id)) {
                        enableControlIDS.push(id);
                      }
                    })
                  }
                }
                break;
              case "3": //hide
                if (hideControlIDS.length == 0) {
                  hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                }
                else {
                  let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                  if (hideCntrIds && hideCntrIds.length > 0) {
                    hideCntrIds.forEach((id) => {
                      if (!hideControlIDS.includes(id)) {
                        hideControlIDS.push(id);
                      }
                    })
                  }
                }
  
                break;
  
              case "4": //disabled
                if (disbledControlIDS.length == 0) {
                  disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                }
                else {
                  let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                  if (disableCntrIds && disableCntrIds.length > 0) {
                    disableCntrIds.forEach((id) => {
                      if (!disbledControlIDS.includes(id)) {
                        disbledControlIDS.push(id);
                      }
                    })
                  }
                }
                break;
            }
  
          });
        }
      })
      //default
      if (value != "") {
        this.staticformFields.forEach((con) => {
  
          if (displayControlIDS.indexOf(con.ID) > -1) {
            con.IS_Dependent_Display = true;
            if (con.CONTROL == "4")
              this.UpdateParentChildDetails(con);
          }
          if (hideControlIDS.indexOf(con.ID) > -1) {
            con.IS_Dependent_Display = false;
            if (con.CONTROL == "4")
              this.UpdateParentChildDetails(con);
          }
          if (enableControlIDS.indexOf(con.ID) > -1) {
            con.IS_Dependent_Enabled = true;
            if (con.CONTROL == "4")
              this.UpdateParentChildDetails(con);
          }
          if (disbledControlIDS.indexOf(con.ID) > -1) {
            con.IS_Dependent_Enabled = false;
            if (con.CONTROL == "4")
              this.UpdateParentChildDetails(con);
          }
  
        });
      }
      else {
        this.UpdateParentChildDetails(question);
      }
  
      if (makeNull == "Y") {
        this.staticformFields.forEach((con) => {
          if (con.IS_Dependent_Display == false) {
            con.ControlValue = "";
            if (con.CONTROL == "10") {
              con.ControlValue = [];
            }
            if (con.CONTROL == "8") {
              con.UploadFiles.forEach((item) => {
                item.Status = "Delete";
              });
            }
            if (con.CONTROL == "6") {
              con.SourceItems.forEach((item) => {
                item.Checked = false;
              });
            }
          }
          if (con.IS_Dependent_Display == true) {
  
          }
          if (con.IS_Dependent_Enabled == false) {
            con.ControlValue = "";
            if (con.CONTROL == "10") {
              con.ControlValue = [];
            }
            if (con.CONTROL == "8") {
              con.UploadFiles.forEach((item) => {
                item.Status = "Delete";
              });
            }
            if (con.CONTROL == "6") {
              con.SourceItems.forEach((item) => {
                item.Checked = false;
              });
            }
          }
          if (con.IS_Dependent_Enabled == true) {
  
          }
        });
      }
    }
    UpdateParentChildDetails(question: any) {
      if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
        question.Control_Condtions = [];
      }
      let displayControlIDS = [];
      let hideControlIDS = [];
      let enableControlIDS = [];
      let disbledControlIDS = [];
  
      question.Control_Condtions.forEach((item) => {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }
  
              break;
            case "2": //enabled
  
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
  
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }
              break;
  
            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }
        });
      })
  
      this.staticformFields.forEach((con) => {
        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
        }
      });
  
    }
 uploadchange(event, ques: SCREEN_CONTROL): void {
      //let Flag = true;
      let Isexe = false;
  let Is5oMB = false;
      if (ques.UploadFiles == undefined || ques.UploadFiles == null)
        ques.UploadFiles = [];
      for (let i = 0; i < event.target.files.length; i++) {
        let uploadFile = new Document_Upload_File();
        let file = event.target.files[i].name;
        let ext = file.match(/\.([^\.]+)$/)[1];
        let filesize = event.target.files[i].size;
  
        if (file != null && (ext == 'exe')) {
          Isexe = true;        
        }
        else if (file != null && ((filesize > 52428800))) {
          Is5oMB = true;
        }
        else {
          this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
            let uploadFile = new Document_Upload_File();
            uploadFile.ID = result.Data[0].FileID;
            uploadFile.DOCUMENT_NAME = event.target.files[i].name;
            uploadFile.File = null;
            uploadFile.Status = "Add";
            uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
            let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
            if (hasValue.length > 0) {
              this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
            }
            else if (ques.ISALLOWMULTIPLEFILES) {
              ques.UploadFiles.push(uploadFile);
            } else {
              ques.UploadFiles.forEach((item) => {
                item.Status = "Delete";
              })
              ques.UploadFiles.push(uploadFile);
            }
          });
  
        }
      }
      if (Is5oMB && Isexe) {
        this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
      }
  
      else if (Is5oMB) {
        this.commonService.ValidationBanner("Accepts maximum file size 50MB");
      }
  
      else if (Isexe) {
        this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
      }
      else {
  
      }
    }
     saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }
   OpenFile(item: Document_Upload_File): void {
      if (item.Status == "Edit") {
        let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
        window.open(Url);
      }
    }
  
    ViewFile(fileID, fileName) {
      this.commonService.previewFile(fileID, fileName, "med");
    }
    DeleteUpload(file, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
        }
      });

    }
  }

  SaveCharitable_GM_APP() {
    let uploadData = new FormData();
    uploadData.append("ScreenControlsData", JSON.stringify(this.GeneralInformationFields));
    uploadData.append("APPLICATION_TYPE_ID", this.Application_Type_ID);
    uploadData.append("SUBMIT_STATUS","0");
    return this.summaryService.SaveCharityGeneralInfo("api/GMGeneralInfoCharitable/Insert", uploadData);
  }

  GetParentScreenFieldsConfigControls(screenCode: string)
  {
    this.commonService.GetScreenConfigControls(screenCode, this.appid, this.appid, (ScreenData) => {
      this.GeneralInformationFields = ScreenData["SCREEN_CONTROL"];
    });
  }

  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }

  singleonChange($event, question) {
    this.IsFormToched = true;
    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question, "Y");
  }

}

